import React, { useState, useEffect, useContext } from "react";
import { Table, Button, Card, Tabs, Image, Radio, message } from "antd";
import { ReloadOutlined, PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import ProductModal from "../../components/AddNewProductModal/ProductModal";
import { AuthContext } from "../../context/AuthContext";
import listApi from "../../services/api";

const { TabPane } = Tabs;

const ProductManagement = () => {
  const { userData } = useContext(AuthContext);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await fetch(listApi.listAllProduct, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          session_id: userData.session_id
        })
      });
      const data = await response.json();
      if (data.code === 200) {
        console.log("check data",data)
        setProducts(data.list_product.map(product => ({
          id: product.ID,
          name: product.product_name,
          type: product.product_type,
          number: product.number,
          price: product.price || 0,
          ship: product.ship_cost?.Cost || 0,
          image: "https://matmasocaivan.com/MMS_data/" + product.picture_url || "https://studiovietnam.com/wp-content/uploads/2020/08/chup-anh-san-pham-phong-thuy-6.jpg",
          product_code: product.product_code,
          product_info: product.product_info
        })));
      }
    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu sản phẩm:", error);
    }
    setLoading(false);
  };

  const handleCreateNewProduct = () => {
    setEditingProduct(null); // Xóa dữ liệu cũ
    setIsModalVisible(true); // Mở modal
  };

  const handleEditProduct = () => {
    setEditingProduct(selectedProduct); // Gán sản phẩm cần chỉnh sửa
    setIsModalVisible(true); // Mở modal
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bạn có chắc chắn muốn xóa sản phẩm này?")) return;  
    try {
      const response = await fetch(listApi.deleteProduct, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: userData.session_id,
          product_id: id
        }),
      });
  
      const text = await response.text(); // Lấy phản hồi dưới dạng text
      console.log("Phản hồi từ API:", text);
  
      const result = JSON.parse(text); // Chuyển đổi thành JSON
      console.log("Kết quả xóa:", result);
  
      // Kiểm tra code=200 thay vì response.ok
      if (result.code === 200) {
        fetchProducts();
        message("Xóa sản phẩm thành công!");
      } else {
        throw new Error(`Lỗi từ server: ${result.message || "Không rõ lỗi"}`);
      }
    } catch (error) {
      console.error("Lỗi khi gọi API:", error);
      message("Lỗi kết nối API, vui lòng kiểm tra lại!");
    }
  };
  
  const columns = [
    {
      title: "Tên sản phẩm",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Radio
          checked={selectedProduct?.id === record.id}
          onChange={() => setSelectedProduct(record)}
        >
          {text}
        </Radio>
      ),
    },
    {
      title: "Loại sản phẩm",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Số lượng",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "Giá",
      dataIndex: "price",
      key: "price",
      render: (price) => `${price.toLocaleString()} VND`,
    },
    {
      title: "Ship",
      dataIndex: "ship",
      key: "ship",
      render: (price) => `${price.toLocaleString()} VND`,
    },
    
   {
    title: "Xóa",
    dataIndex: "ID",
    key: "ID",
    render: (text, record) => (
      <Button
        type="text"
        danger
        icon={<DeleteOutlined />}
        onClick={() => handleDelete(record.id)}
      />
    ),
  },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <Card
        title="📊 DANH SÁCH SẢN PHẨM"
        extra={
          <>
            <Button icon={<ReloadOutlined />} onClick={fetchProducts} loading={loading} style={{ marginRight: "10px" }}>Tải Lại</Button>
            <Button onClick={handleCreateNewProduct} type="primary" icon={<PlusOutlined />}>Tạo Sản Phẩm Mới</Button>
          </>
        }
        style={{ marginBottom: "20px", }}
      >
        <Table columns={columns} dataSource={products} pagination={{ pageSize: 10 }} loading={loading} />
      </Card>

      {/* Modal: Chỉnh sửa hoặc tạo sản phẩm mới */}
      <ProductModal
        product={editingProduct} // Truyền sản phẩm cần chỉnh sửa hoặc null để tạo mới
        visible={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        fetchProducts={fetchProducts}
      />

      {selectedProduct && (
        <Card
          title={`📦 Dòng sản phẩm: ${selectedProduct.name} - mã ${selectedProduct.product_code}`}
          extra={
            <Button onClick={handleEditProduct} icon={<EditOutlined />}>
              Sửa Đổi Thông Tin
            </Button>
          }
        >
          <Tabs defaultActiveKey="1">
            <TabPane tab="Thông tin chi tiết dòng sản phẩm" key="1">
              <p>Mô tả: {selectedProduct.product_info}</p>
              <Image width={300} src={selectedProduct.image} />
            </TabPane>
          </Tabs>
        </Card>
      )}
    </div>
  );
};

export default ProductManagement;
